import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../redux/slices/AllProductSlice';
import banner1 from "../assets/Banners/Watchs/Fire Bolt 4g Pro Smartwatch 1.png";
import banner2 from "../assets/Banners/Watchs/Fire Bolt 4g Pro Smartwatch 2.png";
import banner3 from "../assets/Banners/Watchs/Fire Bolt 4g Pro Smartwatch 3.png";
import { viewCartData } from '../redux/slices/ViewCartSlice';
import { AddToCart } from '../redux/slices/AddTocartSlice';
import { Link, useNavigate } from 'react-router-dom';
import { ProductById } from '../redux/slices/ProductByIdSlice';
import LoaderPage from "./Loader";
import Footer from '../Fotter';

const WatchSale = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { AllData } = useSelector((state) => state.product);
  const [loader, setLoader] = useState(false)
  const [_id, setId] = useState('')

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const topProducts = useMemo(() => {
    return AllData?.products?.slice(0, 5) || [];
  }, [AllData]);

  const bannerImages = [
    banner1,
    banner2,
    banner3
  ];

  useEffect(() => {
    setLoader(true);
    const url =
      "https://www.addmecart.com/shop/watches/smartwatches/fire-boltt-4g-pro-volte-calling-smart-watch-202-tft-display-4g-nano-sim-gps-400mah-battery-blue";
    const extractedTitle = url?.split("/").filter(Boolean).pop();
    const fetchData = async () => {
      try {
        if (extractedTitle) {
          const response = await dispatch(ProductById(extractedTitle));
          const productData = response?.payload?.product;
          const productId = productData?._id;
          setId(productId)
        }
      } catch (error) {
        setLoader(true);
        console.error("Error fetching product-related data:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const handleAddToCartBuy = () => {
    const cartData = {
      productId: _id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        navigate("/cart");
      } else {
        console.log("Responce Error");
      }
    });
  };


  const generateSlug = useCallback((text) => {
    if (!text) return "";

    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\- ]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  });


  return (
    <div>
      <div className="w-full px-4 md:px-10 sm:mt-28  mt-20 sm:space-y-10 space-y-4">
        {bannerImages?.map((img, idx) => (
          <div className="w-full flex justify-center">
            <div className="w-[96%] h-56 sm:h-[500px] relative rounded-md overflow-hidden shadow-md border border-gray-300">
              <img
                src={img}
                alt={`Banner ${idx + 1}`}
                className="w-full h-full object-fill"
              />

              {(idx === 0 ||idx === 1 || idx === 2) && (
                <div className="absolute left-1/2 bottom-2 transform -translate-x-1/2 sm:left-5 sm:translate-x-0">
                  <button onClick={() => handleAddToCartBuy()} className="bg-gradient-to-r from-yellow-400 to-pink-500 text-white text-sm sm:text-lg font-bold px-4 sm:px-10 py-2 sm:py-3 
          rounded-md shadow-lg hover:scale-105 transition-all duration-300">
                    Buy Now
                  </button>
                </div>
              )}
            </div>
          </div>

        ))}

      </div>
      <div className=' px-4 md:px-16 mt-9'>
        <h2 className="text-3xl text-center font-extrabold text-transparent bg-clip-text bg-gradient-to-r
         from-yellow-400 to-blue-600 drop-shadow-md">
          Sale of the Day
        </h2>

        {topProducts?.map((product, index) => {
          const image = product?.images?.productimage1;
          return (
            <Link
              to={`/shop/${product.category ? generateSlug(product.category) : "-"
                }/${product.subcategory
                  ? generateSlug(product?.subcategory)
                  : "-"
                }/${generateSlug(product.title)}`}
              state={{ product }}
            >
              <div
                key={product._id || index}
                className="mt-5 w-full rounded-xl border-4 border-yellow-300 p-3 bg-gradient-to-r from-blue-50 to-yellow-50 shadow-md flex
               flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6 mb-3 "
              >

                {image && (
                  <img
                    src={image}
                    alt={product.title}
                    className="w-full sm:w-72 h-auto object-contain rounded-md shadow"
                  />
                )}
                <div className="flex-1 text-center sm:text-left">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{product.title}</h3>
                  <p className="text-lg font-bold text-green-600">₹{product.salePrice.toLocaleString()}</p>
                  <p className="text-sm text-gray-500 line-through">₹{product.regularPrice.toLocaleString()}</p>
                  <p className="text-sm text-gray-700 mt-2">Category: {product.category}</p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      <div className='mt-5'>
        <Footer />
      </div>
      {loader && <LoaderPage />}
    </div>
  );
};

export default WatchSale;
